import cn from '@ui/utils/cn'

export const sliderConfig = {
  thumbSize: 24,
  trackHeight: 4,
  trackBorderRadius: 8,
  touchMinHeight: 44,
  trackRowHeight: 24,
  segmentGap: 4,
  sideButtonHitSlop: 4,
} as const

export const sliderThumbRadius = sliderConfig.thumbSize / 2
export const sliderThumbOffset = sliderConfig.thumbSize / 2

export const sliderThumbStyle = {
  width: sliderConfig.thumbSize,
  height: sliderConfig.thumbSize,
  borderRadius: sliderThumbRadius,
} as const

export const sliderTrackStyle = {
  height: sliderConfig.trackHeight,
  borderRadius: sliderConfig.trackBorderRadius,
} as const

export const sliderTrackContainerStyle = {
  width: '100%' as const,
  minHeight: sliderConfig.touchMinHeight,
}

export const sContainer = cn(
  'flex w-full flex-row items-center gap-6 rounded-2xl border border-black/10 px-2 py-1'
)

export const sSliderTrack = cn(
  'relative w-full min-w-0 flex-1 touch-none justify-center'
)

export const sPercentageLabel = cn(
  'w-16 shrink-0 text-right font-text-bold text-sm'
)
